let EN = {
  'user': {
    'public': {
      'nickname_title': 'Nickname',
      'nickname_check': 'Please Enter A Nickname',
      'phone_title': 'Mobile Number',
      'phone_check': 'Please Enter Mobile Number',
      'phone_check_message': 'Please Enter The Right Mobile Number',
      'code_title': 'Code',
      'code_check': 'Please Enter Code',
      'code_sure_message': 'Send Successfully, Please Check The Code',
      'code_button': 'Send Code',
      'password_title': 'At Least 6 Digit Password, Case-Sensitive',
      'password_check': 'Please Enter A Password',
      'password_check_message': 'Please Enter A 6-18 Digit Password',
      'password_again_title': 'Confirm Password',
      'password_again_check': 'Please Confirm The Password',
      'password_again_check_message': 'The Password Entered Twice Does Not Match',
      'sure_text': 'OK',
      'login_text': 'Login',
      'forget_text': 'Forgot',
      'regite_text': 'Register'
    },
    'forget': {
      'page_title': 'Forgot Password',
      'page_text': 'Retrieve Password'
    },
    'login': {
      'password_tab': 'Password Login',
      'code_tab': ' Code Login',
      'auto_login': 'Auto Login',
      'other_login': 'Other',
      'regite_text': 'Registe'
    },
    'regist': {
      'login_text': 'Login'
    }
  },
  'project': {
    'public': {
      'see': 'See Us',
      'creat': 'Create',
      'help': 'Help',
      'notice': 'Notice',
      'filterDropDownData': 'Default',
      'myProject': 'My Project',
      'customPlugin': 'Custom Plugin',
      'customComponents': 'Custom Components',
      'setting': 'Setting',
      'message': 'Message',
      'signOut': 'Sign Out',
      'all': 'All',
      'createtime': 'Createtime',
      'usetime': 'Usetime',
      'create': 'Create',
      'default': 'Default',
      'lastCreate': 'Last Create',
      'firstCreate': 'First Create',
      'firstName': 'By Name A-Z',
      'LastName': 'By Name Z-A',
      'signOutTtile': 'Sign Out Success'
    },
    'item': {
      'dragToSort': 'Drag-To-Sort(Undone)',
      'visit': 'Visit',
      'setting': 'Setting',
      'team': 'Member Management',
      'delete': 'Delete',
      'copy': 'Copy',
      'version': 'Version'
    },
    'addItem': {
      'add': 'Create',
      'change': 'Change',
      'cancel': 'Cancel',
      'name': 'Name',
      'enterName': 'Please Enter Name',
      'addItems': 'Create Item'
    },
    'project': {
      'myProject': 'My Project',
      'none': 'None Data',
      'create': 'Create Project',
      'change': 'Change Project',
      'name': 'Project Mame',
      'nameTitle': 'Please Enter Project Name',
      'domain': 'Project Domain',
      'domainTitle': 'Please Enter Project Domain',
      'description': 'Description',
      'descriptionTitle': 'Please Enter Description',
      'deleteSuccess': 'Delete Success'
    }
  },
  'app': {
    'myApp': 'My App',
    'none': 'None Data',
    'create': 'Create App',
    'change': 'Change App',
    'name': 'App Name',
    'nameTitle': 'Please Enter App Name',
    'domain': 'App Domain',
    'domainTitle': 'Please Enter App Domain',
    'description': 'Description',
    'descriptionTitle': 'Please Enter Description',
    'deleteSuccess': 'Delete Success'
  },
  'page': {
    'title': 'Page {Index}',
    'action': {
      'add': 'Create A New Page',
      'copy': 'Copy Page',
      'delete': 'Delete Page'
    }
  },
  'flow': {},
  'process': {},
  'logic': {},
  'editor': {
    'action': {
      'save': {
        'success': 'Save Successfully'
      }
    },
    'header': {
      'preview': 'Preview',
      'fold': 'Fold',
      'save': 'Save',
      'publish': 'Release',
      'setAsTemplate': 'Set As Template',
      'design': 'Design',
      'db': 'Model',
      'logic': 'Logic',
      'importExcel': 'Import Excel',
      'toPage': 'Back To Apps'
    },
    'sidebar': {
      'layout': 'Layout',
      'component': 'Components',
      'function': 'Functions'
    },
    'centerPanel': {
      'mode': {
        'edit': 'Edit',
        'preview': 'Preview'
      },
      'contextMenu': {
        'copy': 'Copy',
        'delete': 'Delete',
        'moveToTop': 'Top',
        'moveToBottom': 'Bottom',
        'moveUp': 'Move Up',
        'moveDown': 'Move Down'
      }
    },
    'fixedTool': {
      'fold': 'Folding',
      'delete': 'Delete',
      'undo': 'Undo',
      'redo': 'Redo',
      'preview': 'Preview',
      'copyCurrentPage': 'Copy The Current Page',
      'importPSD': 'Import PSD',
      'zoomIn': 'Zoom Out',
      'zoomOut': 'Zoom In'
    },
    'editPanel': {
      'component': {
        'prop': 'Props',
        'style': 'Style',
        'event': 'Events'
      },
      'tab': {
        'prop': 'Property',
        'animation': 'Animation',
        'action': 'Action',
        'script': 'Script',
        'background': 'Background'
      },
      'animation': {
        'add': 'Create Animation',
        'run': 'Run Animation',
        'type': 'Animation Type',
        'duration': 'Animated Duration',
        'delay': 'Animation Delay',
        'iteration': 'Number Of Runs',
        'inifinite': 'Looping',
        'list': 'Select Animation',
        'title': 'Animation {Index}'
      },
      'common': {
        'empty': 'Please Choose A Control!'
      }
    },
    'design': {
      'propsList': {
        'prop': 'Prop',
        'style': 'Style',
        'event': 'Event'
      },
      'contextmenuData': {
        'page': {
          'addPage': 'Create Page',
          'settingPage': 'Change Page',
          'removePage': 'Delete Page',
          'mkdir': 'Create Folder'
        },
        'directory': {
          'mkdir': 'Create Folder',
          'settingDir': 'Change Folder',
          'rmRf': 'Delete Folder',
          'addPage': 'Create Page'
        }
      },
      'dbContextmenuData': {
        'table': {
          'add': 'Create Table',
          'setting': 'Change Table',
          'remove': 'Remove Table'
        },
        'field': {
          'add': 'Create Field',
          'setting': 'Change Field',
          'remove': 'Remove Field'
        },
        'dataSource': {
          'add': 'Create Field'
        }
      },
      'addItemSettings': {
        'page': {
          'title': 'Create Page',
          'addList': {
            'text': 'Page Name',
            'message': 'Please Enter Page Name'
          }

        },
        'directory': {
          'title': 'Create Folder',
          'addList': {
            'text': 'Folder Name',
            'message': 'Please Enter Folder Name'
          }

        },
        'dbTable': {
          'title': 'Create Table',
          'addList': {
            'nametext': 'Table Name(en)',
            'namemessage': 'Please Enter Table Name',
            'cntext': 'Table Name(cn)',
            'cnmessage': 'Please Enter Table Name',
            'destext': 'Description',
            'desmessage': 'Please Enter Description'
          }
        },
        'dbField': {
          'title': 'Create Field',
          'addList':
            {
              'nametext': 'Name',
              'namemessage': 'Please Enter Name',
              'destext': 'Description',
              'desmessage': 'Please Enter Description',
              'typetext': 'Type',
              'typemessage': 'Please Choose Type',
              'typevalues': {
                'text': 'Text',
                'int': 'Int',
                'tinyint': 'Tinyint',
                'smallint': 'Smallint',
                'mediumint': 'Mediumint',
                'bigint': 'Bigint',
                'char': 'Vhar',
                'varchar': 'Varchar',
                'float': 'Float',
                'double': 'Double',
                'timestamp': 'Timestamp'
              }
            }
        }
      },
      'message': {
        'delPage': 'At Least Have A Root Page',
        'delSuccess': 'Delete Success',
        'addSuccess': 'Create Success',
        'changeSuccess': 'Change Sccess',
        'changePage': 'Change Page',
        'createFolder': 'Create Folder',
        'createPage': 'Create Page',
        'changeFolder': 'Change Folder',
        'levelError': 'Vevel Is Error Please Change',
        'changeTable': 'Change Table',
        'createTable': 'Create Table',
        'changeFields': 'Change Fields',
        'createFields': 'Create Fields'
      }
    }
  }
}

/*
function upperCase (obj) {
  for (let k in obj) {
    if (typeof obj[k] === 'object') {
      upperCase(obj[k])
    } else {
      obj[k] = obj[k].replace(/\b[a-z]/g, $0 => $0.toUpperCase())
    }
  }
}
*/
// upperCase(EN)

export default EN
